module.exports = __webpack_public_path__ + "img/img-default-notFound.7945fdcb.png";